import React from 'react';

import {StyledStepAttachedLi} from 'app/procedures/styles';
import {gt} from 'app/utils/i18n';

import {StepViewCheckboxField} from './checkbox-field';
import {StepViewFileField} from './file-field';
import {StepViewRadiobuttonField} from './radiobutton-field';
import {StepViewTextField} from './text-field';
import {StepViewTextareaField} from './textarea-field';

import {
  StepFormFieldsTitle,
  StyledStepContentSeparatorDiv,
} from '../structures';

import type {StepFieldTypeWithDiff} from 'app/general/types';

interface Props {
  fields?: Array<StepFieldTypeWithDiff>;
  showNotification: (message: string) => void;
}

export const StepViewFieldWrapper = ({fields, showNotification}: Props) => {
  return fields != null && fields.length > 0 ? (
    <StyledStepContentSeparatorDiv className="files">
      <StepFormFieldsTitle />
      <ul className="list-group">
        {fields.map((field) => (
          <StyledStepAttachedLi
            key={field.id}
            className={`list-group-item ${field.changedState || ''}`}
          >
            <div
              onClick={() =>
                showNotification(
                  gt('Start this procedure to begin filling fields')
                )
              }
            >
              {field.type === 'text' ? (
                <StepViewTextField field={field} />
              ) : field.type === 'checkbox' ? (
                <StepViewCheckboxField field={field} />
              ) : field.type === 'date' ? (
                <StepViewTextField field={field} />
              ) : field.type === 'radio' ? (
                <StepViewRadiobuttonField field={field} />
              ) : field.type === 'file' ? (
                <StepViewFileField field={field} />
              ) : field.type === 'textarea' ? (
                <StepViewTextareaField field={field} />
              ) : null}
            </div>
          </StyledStepAttachedLi>
        ))}
      </ul>
    </StyledStepContentSeparatorDiv>
  ) : null;
};
